import OrderItem from '@/components/smartComponent/OrderItem'
import { MessageBox, Indicator, Toast } from 'mint-ui'
import { mapGetters, mapMutations } from 'vuex'
import { PLATFORM_TYPE_DETAIL } from '@/constants/index'
import { ReceiveConfirm, PddReceiveConfirm, JdReceiveConfirm, DouDianReceiveConfirm, CancelSaleTaskAccept, SpreadFeedbackCancel, TgcReceiveConfirm } from '@/api/my'
import { DeleteOrder } from '@/api/order'
export default {
  computed: {
    ...mapGetters(['getTempOrderInfo'])
  },
  components: {
    OrderItem
  },
  methods: {
    ...mapMutations(['SET_TEMP_ORDER_INFO', 'SET_IS_HAVE_UNFINISHED_ORDER', 'SET_GUIDE_EVALUATION_POPUP', 'SET_CUR_PLATFORM_TYPE']),
    // 进入详情页
    entoDetailPage(productId) {
      this.$router.push({
        name: 'goodsDetail',
        query: {
          productID: productId
        }
      })
    },
    waitAudit({ SystemReviewCount = null }) {
      let tempMessage = '订单正在审核中，请耐心等待。如有疑问请在公众号菜单栏中点击【联系客服 - 人工客服】'
      if (SystemReviewCount === null || SystemReviewCount >= 3) {
        tempMessage = '平台会根据你提交的订单截图在24小时内审核完毕，如有疑问请在公众号菜单栏中点击【联系客服 - 人工客服】'
      }
      MessageBox({
        title: '提示',
        message: tempMessage,
        showCancelButton: false,
        confirmButtonText: '我知道了',
        confirmButtonClass: 't_f23030'
      })
    },
    // 查看差价反馈
    checkPeiceFeedback({ itemInfo = {} }) {
      this.SET_TEMP_ORDER_INFO(itemInfo)
      this.$router.push({
        name: 'checkPeiceFeedback'
      })
    },
    // 取消反馈
    cancelFeebback({ taskID = '', goBack = false }) {
      MessageBox({
        title: '提示',
        message: '确定取消此次差价反馈',
        showCancelButton: true,
        confirmButtonClass: 't_f23030'
      }).then((action) => {
        if (action === 'confirm') {
          Indicator.open({
            text: '加载中',
            spinnerType: 'triple-bounce'
          })
          SpreadFeedbackCancel({ taskId: taskID })
            .then((res) => {
              Indicator.close()
              if (!goBack) {
                this.dataList = []
                this.currentPage = 1
                this.fetchData()
              }
              this.$router.replace({
                name: 'order'
              })
            })
            .catch((res) => {
              Indicator.close()
              if (res.ErrMsg) {
                Toast(res.ErrMsg)
              }
            })
        }
      })
    },
    // 删除订单接口
    deleteOrder(taskID) {
      MessageBox({
        title: '提示',
        message: '订单删除后，将无法恢复，确认删除吗？',
        showCancelButton: true,
        confirmButtonClass: 't_f23030'
      }).then((action) => {
        if (action === 'confirm') {
          Indicator.open({
            text: '加载中',
            spinnerType: 'triple-bounce'
          })
          DeleteOrder({ taskID: taskID })
            .then(() => {
              Indicator.close()
              // this.dataList = [];
              // this.currentPage = 1;
              // this.fetchData();
              for (var key in this.dataList) {
                if (this.dataList[key].TaskID === taskID) {
                  this.dataList.splice(key, 1)
                }
              }
            })
            .catch((res) => {
              Indicator.close()
              if (res.ErrMsg) {
                Toast(res.ErrMsg)
              }
            })
        }
      })
    },
    // 进入基础销量模式第一步页面
    goBaseSaleStepOne(itemData) {
      let replaceRouters = ['checkPeiceFeedback']
      let currentRouter = this.$router.currentRoute.name
      let isFreeCard = false
      if (itemData.OrderType) isFreeCard = true
      let toRouteName = 'baseStepOne'
      let queryData = {
        productId: itemData.ProductID,
        isFreeCard: isFreeCard
      }
      if (itemData.ShopType === this.PLATFORM_TYPE['拼多多']) {
        toRouteName = 'pddBaseStepOne'
        queryData.taskId = itemData.TaskID
      } else {
        queryData.wAPPicUrl = encodeURI(itemData.PicUrl)
      }
      if (replaceRouters.indexOf(currentRouter) !== -1) {
        // 进入购买第一步
        this.$router.replace({
          name: toRouteName,
          query: queryData
        })
      } else {
        this.$router.push({
          name: toRouteName,
          query: queryData
        })
      }
    },
    // 继续提交
    continueSubmit(itemData) {
      let replaceRouters = ['checkPeiceFeedback']
      let currentRouter = this.$router.currentRoute.name
      if (itemData.IsBaseSaleModel) {
        // 基础销量模式
        this.goBaseSaleStepOne(itemData)
      } else {
        // 普通模式
        let toRouteName = ''
        const platformType = this.$utils.shopTypeNumChangeToPlatformType(itemData.ShopType)
        this.SET_CUR_PLATFORM_TYPE(platformType)
        switch (platformType) {
          case this.PLATFORM_TYPE['拼多多']:
            toRouteName = 'pddStepThree'
            break
          case this.PLATFORM_TYPE['京东']:
            toRouteName = 'jdStepThree'
            break
          case this.PLATFORM_TYPE['抖店']:
            toRouteName = 'dyStepThree'
            break
          default:
            // 淘宝、天猫、淘工厂
            toRouteName = 'stepThree'
            break
        }
        this.SET_TEMP_ORDER_INFO(itemData)
        if (replaceRouters.indexOf(currentRouter) !== -1) {
          this.$router.replace({
            name: toRouteName,
            query: {
              readyTaskId: itemData.TaskID
            }
          })
        } else {
          this.$router.push({
            name: toRouteName,
            query: {
              readyTaskId: itemData.TaskID
            }
          })
        }
      }
    },
    // 继续搜索
    submitSearch(itemData) {
      let isFreeCard = false
      if (itemData.OrderType) isFreeCard = true
      if (itemData.IsBaseSaleModel) {
        // 基础销量模式
        this.goBaseSaleStepOne(itemData)
      } else {
        // 普通模式
        let toRouteName = ''
        const platformType = this.$utils.shopTypeNumChangeToPlatformType(itemData.ShopType)
        this.SET_CUR_PLATFORM_TYPE(platformType)
        switch (platformType) {
          case this.PLATFORM_TYPE['拼多多']:
            toRouteName = 'pddStepOne'
            break
          case this.PLATFORM_TYPE['京东']:
            toRouteName = 'jdStepOne'
            break
          case this.PLATFORM_TYPE['抖店']:
            toRouteName = 'dyStepOne'
            break
          default:
            // 淘宝、天猫、淘工厂
            toRouteName = 'stepOne'
            break
        }
        this.$router.push({
          name: toRouteName,
          query: {
            productId: itemData.ProductID,
            wAPPicUrl: encodeURI(itemData.PicUrl),
            isFreeCard: isFreeCard
          }
        })
      }
    },
    // 重新提交
    submitAgain(taskID) {
      this.$router.push({
        name: 'orderSubmit',
        query: {
          taskID: taskID,
          submitAgain: 'again'
        }
      })
    },
    // 领取返利
    confirmReceipt(taskID, productId, shopType) {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      this.platformType = this.$utils.shopTypeNumChangeToPlatformType(shopType)
      let res = null
      switch (this.platformType) {
        case this.PLATFORM_TYPE['拼多多']:
          res = PddReceiveConfirm({ taskID: taskID })
          break
        case this.PLATFORM_TYPE['京东']:
          res = JdReceiveConfirm({ taskID: taskID })
          break
        case this.PLATFORM_TYPE['抖店']:
          res = DouDianReceiveConfirm({ taskID: taskID })
          break
        case this.PLATFORM_TYPE['淘工厂']:
          res = TgcReceiveConfirm({ taskID: taskID })
          break
        default:
          // 淘宝/天猫
          res = ReceiveConfirm({ taskID: taskID })
          break
      }
      res
        .then((res) => {
          Indicator.close()
          this.taskId = taskID
          this.productId = productId
          this.isLogisticsFinished = res.IsLogisticsFinish
          this.isExistLogisticsAudit = res.IsExistLogisticsAudit
          this.isTradeFinish = res.IsTradeFinish
          this.isMerchantPay = res.IsMerchantPay
          let IsSendInvitationEvaluate = res.IsSendInvitationEvaluate
          let RewardFreeCard = res.RewardFreeCard
          if (res.IsLogisticsFinish !== false && res.IsMerchantPay && res.IsTradeFinish) {
            this.dataList = []
            this.currentPage = 1
            this.fetchData()
          }
          if (IsSendInvitationEvaluate) {
            this.SET_GUIDE_EVALUATION_POPUP({
              isShow: true,
              RewardFreeCard: RewardFreeCard
            })
          } else {
            this.dialogIsShow = true
          }
        })
        .catch((res) => {
          Indicator.close()
          // this.orderErrorMsg = `此订单已在${shopType === 2 ? "拼多多" : "淘宝"
          //   }申请退款，无法领取返利。如未退款/已取消退款，请联系客服处理`;
          // if (res.ErrMsg === this.orderErrorMsg && res.Data.IsOrderLock) {
          //   this.receiptDialogShow = true;
          // } else {
          //   Toast(res.ErrMsg);
          // } $utils.shopTypeNumChangeToPlatformType(shopType)
          this.orderErrorMsg = res.ErrMsg
            ? res.ErrMsg
            : `此订单已在${PLATFORM_TYPE_DETAIL[this.$utils.shopTypeNumChangeToPlatformType(shopType)].collectively}申请退款，无法领取返利。如未退款/已取消退款，请联系客服处理`
          this.receiptDialogShow = true
        })
    },
    // 查看返利
    checkRebate(PlatformOrderID) {
      this.$router.push({
        name: 'balance',
        query: {
          type: 0,
          PlatformOrderID: PlatformOrderID
        }
      })
    }
  },
  beforeDestroy() {
    this.searchPageShow = false
    if (this.TAB_BAR_SHOW) {
      this.TAB_BAR_SHOW(true)
    }
  }
}
